module.exports = __webpack_public_path__ + "static/media/classroom_bottom_animation_1.a8890474.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/classroom_bottom_animation_1.png
// module id = 1945
// module chunks = 6